<script>
import Toolbar from './toolbar'
import TopMenuPatient from './topMenuPatient'
import TopMenuProfessional from './topMenuProfessional'
import Sidebar from '../sidebar'
import SidebarProfessional from '../professional/sidebar'
import { routeIsProfessional, routeIsSettings } from '@/helpers/routes'
import { mapActions, mapGetters } from 'vuex'
import ChangePasswordMobile from './changePasswordMobile'
import bus from '@/utils/eventBus'

export default {
  name: 'layout-header',

  computed: {
    routeIsSettings () {
      return routeIsSettings(this.$route)
    },
    routeIsProfessional () {
      return routeIsProfessional(this.$route)
    },
    ...mapGetters(['user', 'userIsPatient', 'userIsProfessional', 'userIsCompany'])
  },
  methods: {
    ...mapActions(['logout']),
    doLogout () {
      const currentUser = { ...this.user }
      const isProfessional = (user) => {
        return user.type === 'professional'
      }

      const isCompany = (user) => {
        return user.type === 'company'
      }

      this.logout()
        .then(() => {
          if (isProfessional(currentUser)) {
            return this.$router.push({name: 'auth.professional.login'})
          }

          if (isCompany(currentUser)) {
            return this.$router.push({name: 'auth.company.login'})
          }

          window.location.href = '/'
        })
    }
  },
  data: () => {
    return {
      mobileMenuOn: false
    }
  },
  mounted: function () {
    // evento esconde menu
    bus.$on('hidden-mobile-menu', values => {
      this.mobileMenuOn = values.status
    })
  },
  components: {
    Toolbar,
    TopMenuPatient,
    TopMenuProfessional,
    Sidebar,
    SidebarProfessional,
    ChangePasswordMobile
  }
}
</script>

<template lang="pug">
  .row
      header.navbar-fixed-top(:class="{'profile' : !routeIsProfessional}")
        .col-xs-12.col-sm-3.col-md-2.text-center
         router-link(:to="{name: 'patient.dashboard.index'}", v-if="userIsPatient")
          svg
           image(xlink:href='/static/images/logo.svg', src='/static/images/logo.png', width='115', height='50')
         router-link(:to="{name: 'professional.dashboard.professional.index'}", v-if="userIsProfessional")
          svg
            image(xlink:href='/static/images/logo.svg', src='/static/images/logo.png', width='115', height='50')
         router-link(:to="{name: 'professional.dashboard.company.index'}", v-if="userIsCompany")
          svg
            image(xlink:href='/static/images/logo.svg', src='/static/images/logo.png', width='115', height='50')
        .hidden-xs.hidden-sm.col-md-7.top-menu-xs
          TopMenuPatient(v-if='!routeIsProfessional')
          TopMenuProfessional(v-if='routeIsProfessional')

        .hidden-xs.col-xs-12.col-sm-8.col-md-3.text-right
          toolbar
      .menu-trigger.trigger-menu-off.col-xs-1.col-sm-1.hidden-md.hidden-lg(:class="{'trigger-menu-on': mobileMenuOn}",  @click='mobileMenuOn = !mobileMenuOn')
        .menu-icon
          .first-line
          .second-line
          .third-line

      .menu-mobile.col-xs-10.col-sm-4.hidden-md.hidden-lg.menu-off(:class="{'menu-on': mobileMenuOn, 'paciente' : !routeIsProfessional}")
        .row.user-mobile
          .col-xs-3
            img.img-circle(:src="user.avatar")
          .col-xs-8.name
            span {{ user.name }}
        .menu-mobile-itens
          sidebar(v-if="!routeIsProfessional")
          sidebar-professional(v-if='routeIsProfessional')
          ul.secondary.hidden-sm
            li
              router-link(:to="{name: 'settings.profile.me'}", @click.native="mobileMenuOn = false")
                span 
                | Editar meu Perfil
            li
              router-link(:to="{name: 'settings.profile.me'}", @click.native="mobileMenuOn = false")
                span 
                |Alterar Foto
            li(data-toggle='collapse', data-target='#menu-password-mobile')
                span 
                | Alterar Senha
            change-password-mobile

            a(href='#')
              li
                span 
                | Ajuda
            a(href='')
              li
                span 
                | Configurações

            a(@click.prevent='doLogout()')
              li
                span 
                | Sair

</template>



// WEBPACK FOOTER //
// src/layout/headers/index.vue